import React from 'react';
import { Button } from '../../../../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../../../components/ui/dropdown-menu';
import LanguageSelector from '../../../../components/blocks/language-selector/language-selector';

import type {
  IconButtonHeaderItem,
  IconTextButtonHeaderItem,
  IconDropdownMenuHeaderItem,
  LanguageSelectorHeaderItem,
  DropdownOption,
  IconTextButtonDropdownHeaderItem,
  AppSwitcherHeaderItem,
} from '../types/header';
import { Icon } from '../../../../components/blocks/menu-icon/menu-icon';
import { AppSwitcher } from '../../../../components/blocks/app-switcher';

export const HeaderIconButton: React.FC<IconButtonHeaderItem> = ({
  id,
  iconName,
  onClick,
  ariaLabel,
}) => (
  <Button
    variant="ghost"
    size="icon"
    className="rounded-full hover:bg-muted"
    onClick={onClick}
    aria-label={ariaLabel}
    key={id}
  >
    <Icon name={iconName} className="!w-5 !h-5 text-medium-emphasis" />
  </Button>
);

export const HeaderAppSwitcher: React.FC<AppSwitcherHeaderItem> = ({ id }) => (
  <AppSwitcher key={id} />
);

export const HeaderLanguageSelector: React.FC<LanguageSelectorHeaderItem> = ({ id }) => (
  <LanguageSelector key={id} />
);

export const HeaderIconTextButton: React.FC<IconTextButtonHeaderItem> = ({
  id,
  iconName,
  text,
  onClick,
  ariaLabel,
}) => (
  <Button
    variant="outline"
    className="rounded-full hover:bg-muted"
    onClick={onClick}
    aria-label={ariaLabel}
    key={id}
  >
    <div className="flex items-center gap-1.5">
      <Icon name={iconName} className="!w-5 !h-5 text-medium-emphasis" />
      <span className="text-sm text-medium-emphasis">{text}</span>
    </div>
  </Button>
);

export const HeaderIconDropdownMenu: React.FC<IconDropdownMenuHeaderItem> = ({
  id,
  triggerIconName,
  options,
  ariaLabel,
}) => (
  <DropdownMenu key={id}>
    <DropdownMenuTrigger asChild>
      <Button
        variant="ghost"
        size="icon"
        className="rounded-full hover:bg-muted"
        aria-label={ariaLabel}
      >
        <Icon name={triggerIconName} size={18} className="text-high-emphasis" />
      </Button>
    </DropdownMenuTrigger>
    {options && options.length > 0 && (
      <DropdownMenuContent side="bottom" align="start" className="w-48">
        {options.map((option: DropdownOption) => (
          <DropdownMenuItem
            key={option.id}
            onClick={option.callback}
            className="flex items-center gap-2"
          >
            <Icon name={option.icon} size={16} className="text-high-emphasis" />
            <span>{option.text}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    )}
  </DropdownMenu>
);

export const HeaderIconTextButtonDropdown: React.FC<IconTextButtonDropdownHeaderItem> = ({
  id,
  triggerIconName,
  options,
  ariaLabel,
  text,
}) => (
  <DropdownMenu key={id}>
    <DropdownMenuTrigger asChild>
      <Button
        variant="ghost"
        size="icon"
        className="rounded-full hover:bg-muted"
        aria-label={ariaLabel}
      >
        <Icon name={triggerIconName} size={18} className="text-high-emphasis" />
        <span className="text-sm text-medium-emphasis">{text}</span>
      </Button>
    </DropdownMenuTrigger>
    {options && options.length > 0 && (
      <DropdownMenuContent side="right" align="end" className="w-48">
        {options.map((option: DropdownOption) => (
          <DropdownMenuItem
            key={option.id}
            onClick={option.callback}
            className="flex items-center gap-2"
          >
            <Icon name={option.icon} size={16} className="text-high-emphasis" />
            <span>{option.text}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    )}
  </DropdownMenu>
);
